module.exports = __webpack_public_path__ + "assets/img/close.b3f9bfa9.png";